$(document).ready(function () {
    $(".count").each(function () {
        const originalValue = parseFloat($(this).text());
        $(this).data("final-value", originalValue);
        $(this).text("0");
    });

    // Function to animate numbers, dynamically handling decimals
    function animateCount($element) {
        const finalValue = $element.data("final-value");
        const hasDecimal = String(finalValue).includes('.');

        $({ countValue: 0 }).animate(
            { countValue: finalValue },
            {
                duration: 2000,
                easing: "swing",
                step: function (now) {
                    $element.text(hasDecimal ? now.toFixed(1) : Math.floor(now));
                },
                complete: function () {
                    $element.text(finalValue);
                },
            }
        );
    }

    // Check if the element is in view
    function isInViewport($element) {
        const elementTop = $element.offset().top;
        const viewportHeight = $(window).height();

        const triggerPosition = $(window).scrollTop() + viewportHeight * 0.8;

        return elementTop <= triggerPosition;
    }

    // Watch for ".count" elements to come into view
    function watchForCounts() {
        $(".count").each(function () {
            const $this = $(this);
            if (!$this.hasClass("animated") && isInViewport($this)) {
                $this.addClass("animated");
                animateCount($this);
            }
        });
    }

    // Initial check and bind the scroll event
    watchForCounts();
    $(window).on("scroll resize", watchForCounts);
});
